import { Component, Input, Inject, OnInit } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwInfotip
 * @module mw.components.tooltip
 *
 * @param {string} [icon='action:ic_info_outline_24px'] - If provided, will change the icon in the info tip.
 * @param {string} [text-content] - String that will be bound onto the infotip tooltip.
 *
 * @description
 * `<mw-infotip>` is a component used to generate an icon and tooltip associated with the icon that needs the ability for multiple lines.
 *
 * @usage
 * <hljs hljs-language="html">
 * <mw-infotip text-content="My infotip text here"></mw-info-tip>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-infotip',
    template: `
        <md-icon ng-mouseover="$ctrl.handleMouseover($event)" md-svg-src="{{ $ctrl.icon }}" class="mw-infotip-trigger"></md-icon>
        <md-tooltip ng-if="$ctrl.translatedText" class="mw-infotip" md-direction="{{$ctrl.infotipDirection}}">
            {{$ctrl.translatedText}}
        </md-tooltip>
    `
})
export class InfotipComponent implements OnInit{
    @Input('@') icon: string = 'action:ic_info_outline_24px';
    @Input('@') textContent: string = '';
    private infotipDirection: string = 'top';
    private translatedText: string;

    constructor(
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$translate') private $translate
    ) {
      'ngInject';
    }

    ngOnInit() {
        this.$translate(this.textContent).then(
            text => { this.translatedText = text },
            id => { this.translatedText = id }
        );
    }

    handleMouseover($event) {
        // approximates the height of the infotip and changes the md-direction to give
        // enough space to pop out from
        let approxTooltipheight = Math.ceil((this.translatedText.length / 2) / 100) * 100;
        let tooltipFromBrowserBottom = this.$window.innerHeight - $event.clientY;
        if (tooltipFromBrowserBottom <= approxTooltipheight) {
            this.infotipDirection = 'top';
        } else {
            this.infotipDirection = 'bottom';
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/tooltip/infotip.tooltip.component.ts